import { render, staticRenderFns } from "./UI.vue?vue&type=template&id=54b42f38&scoped=true&"
import script from "./UI.vue?vue&type=script&lang=js&"
export * from "./UI.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ui.css?vue&type=style&index=0&id=54b42f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b42f38",
  null
  
)

export default component.exports